// src/components/Admin.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AssLoginImg from '../../Images/AssLogin.png'
import "./Admin.css";
import ApiBaseUrl from "../../ApiBaseUrl/ApiBaseUrl.json";

function Admin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [animateOut, setAnimateOut] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const navigate = useNavigate();

  // Clear session on load (forces re-login on refresh/back)
  useEffect(() => {
    sessionStorage.removeItem("adminLoggedIn");
  }, []);

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePassword = (password) =>
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setAlertMessage("❌ Invalid email format.");
      return;
    }

    if (!validatePassword(password)) {
      setAlertMessage(
        "❌ Password must contain at least 8 characters, 1 letter, 1 number, and 1 special character."
      );
      return;
    }

    try {
      const response = await fetch(`${ApiBaseUrl.ApiBaseUrl}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log("Login response:", data);

      if (response.ok && data.success) {
        sessionStorage.setItem("adminLoggedIn", "true"); // 🟢 Track login
        setAnimateOut(true);
        setTimeout(() => {
          navigate("/admin/results");
        }, 600);
      } else {
        setAlertMessage("❌ " + data.message);
      }
    } catch (err) {
      console.error("Login error:", err);
      setAlertMessage("❌ Server error. Please try again.");
    }
  };

  return (
    <div className="login-page">
      {/* Left Panel */}
      <div className="left-panel">
      <img src={AssLoginImg} alt="Login Visual" className="left-pannel-img"/>
      </div>

      {/* Right Panel */}
      <div className={`right-panel ${animateOut ? "fade-out" : ""}`}>
        <div className="form-box">
          <h2 className="login-title">Admin Login</h2>
          <p className="login-subtitle">Sign in with admin account</p>

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <input
                type="email"
                placeholder=" "
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label>Admin Email</label>
            </div>

            <div className="input-group">
              <input
                type="password"
                placeholder=" "
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <label>Password</label>
            </div>

            <button type="submit" className="login-btn">Login</button>
          </form>
        </div>
      </div>

      {/* Alert Popup */}
      {alertMessage && (
        <div className="alert-overlay">
          <div className="alert-box">
            <p>{alertMessage}</p>
            <button className="alert-close" onClick={() => setAlertMessage("")}>×</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Admin;